import { getUser } from './getUser';
import { IApplicationState } from '../../types/redux';

export const getUserPhone = (state: IApplicationState) => {
  const user = getUser(state);
  const phone = user?.phone;

  return phone ? phone : null;
};
